<jw-modal id='workshopEditFitterModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Assign Fitter</h1>
  <div class="form-row">
    <div class="form-group">
      <input type="radio" [checked]='this.type === "own"' name='group[]' (change)="this.onOptionSelect($event, 'own')">
      <label for="inputEmail4">&nbsp;&nbsp;Own Fitter</label>
    </div>
    <div class="form-group">
      &nbsp;&nbsp;<input type="radio" name='group[]' [checked]='this.type === "sub"' (change)="this.onOptionSelect($event, 'sub')" />
      <label for="inputEmail4">&nbsp;&nbsp;Subcontractor</label>
    </div>
  </div>

  <div class='form-row'>
    <div class="form-group col-md-4">
      <label for="inputEmail4">Name</label>
      <input type="text" [(ngModel)]='this.assignment.name' [class.is-invalid]='!this.assignment.name' name='name' class="form-control" id="inputEmail4">
    </div>
    @if (this.type === "own") {
      <div class="form-group col-md-4">
        <label for="inputEmail4">Depot</label>
        <select class='form-control' [class.is-invalid]='this.assignment.depotId === -1' (change)='onDepotChanged($event)'>
          <option value='-1'>Select a depot</option>
          @for (depot of this.depots; track depot) {
            <option [selected]='this.assignment.depotId === depot.id' [value]='depot.id'>{{ depot.name }}</option>
          }
        </select>
      </div>
    }
    @if (this.type === "own") {
      <div class="form-group col-md-4">
        <label for="inputEmail4">Fitter</label>
        <select class='form-control' [class.is-invalid]='this.assignment.fitterId === -1' (change)='this.assignment.fitterId = +$event.target.value; this.assignment.fitter = {id: this.assignment.fitterId };'>
          <option value='-1'>Select a fitter</option>
          @for (fitter of this.fitters; track fitter) {
            <option [selected]='this.assignment.fitterId === fitter.id' [value]='fitter.id'>{{ fitter.firstName }} {{ fitter.lastName }}</option>
          }
        </select>
      </div>
    }
    <div class="form-group col-md-4">
      <label for="inputEmail4">Fitter Start Time</label>
      <input type="time" [(ngModel)]='this.assignment.fitterStartTime' [class.is-invalid]='!this.assignment.fitterStartTime' name='name' class="form-control" id="inputEmail4">
    </div>

    @if (this.type === "sub") {
      <div class="form-group col-md-4">
        <label for="inputEmail4">Subcontractors</label>
        <select class='form-control' [class.is-invalid]='this.assignment.subcontractorId === -1' (change)='this.assignment.subcontractorId = +$event.target.value;this.assignment.subcontractor = {id: this.assignment.subcontractorId};this.loadSubcontractorDepots()'>
          <option value='-1'>Select a subcontractor</option>
          @for (subcontractor of this.subcontractors; track subcontractor) {
            <option [selected]='this.assignment.subcontractorId === subcontractor.id' [value]='subcontractor.id'>{{ subcontractor.name }}</option>
          }
        </select>
      </div>
    }
    @if (this.type === "sub") {
      <div class="form-group col-md-4">
        <label for="inputEmail4">Subcontractor Depots</label>
        <select class='form-control' [class.is-invalid]='this.assignment.subcontractorDepotId === -1' (change)='this.assignment.subcontractorDepotId = +$event.target.value;this.assignment.subcontractorDepot= {id: this.assignment.subcontractorDepotId};'>
          <option value='-1'>Select a subcontractor</option>
          @for (subcontractor of this.subcontractorDepots; track subcontractor) {
            <option [selected]='this.assignment.subcontractorDepotId === subcontractor.id' [value]='subcontractor.id'>{{ subcontractor.name }}</option>
          }
        </select>
      </div>
    }
  </div>

  <button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
</jw-modal>
